
import { WorldCountry } from '../types';

export const vietnamExpanded2: WorldCountry = {
  code: 'VN',
  name: 'Vietnam',
  slug: 'vietnam',
  population: 98168000,
  topCities: [
    // Ciudades principales existentes
    { name: 'Ho Chi Minh City', slug: 'ho-chi-minh-city', population: 9077000 },
    { name: 'Hanoi', slug: 'hanoi', population: 8053000 },
    { name: 'Hai Phong', slug: 'hai-phong', population: 2028000 },
    { name: 'Da Nang', slug: 'da-nang', population: 1230000 },
    { name: 'Can Tho', slug: 'can-tho', population: 1238000 },
    { name: 'Bien Hoa', slug: 'bien-hoa', population: 1104000 },
    { name: 'Hue', slug: 'hue', population: 455230 },
    { name: 'Nha Trang', slug: 'nha-trang', population: 423000 },
    { name: 'Buon Ma Thuot', slug: 'buon-ma-thuot', population: 340000 },
    { name: 'Vung Tau', slug: 'vung-tau', population: 327000 },
    
    // Ciudades adicionales para llegar a 100+
    { name: 'Quy Nhon', slug: 'quy-nhon', population: 284535 },
    { name: 'Thai Nguyen', slug: 'thai-nguyen', population: 270000 },
    { name: 'Phan Thiet', slug: 'phan-thiet', population: 206000 },
    { name: 'Thai Binh', slug: 'thai-binh', population: 210000 },
    { name: 'Long Xuyen', slug: 'long-xuyen', population: 280000 },
    { name: 'Nam Dinh', slug: 'nam-dinh', population: 181900 },
    { name: 'Cam Ranh', slug: 'cam-ranh', population: 180000 },
    { name: 'Vinh', slug: 'vinh', population: 490000 },
    { name: 'Rach Gia', slug: 'rach-gia', population: 228356 },
    { name: 'Cam Pha', slug: 'cam-pha', population: 185000 },
    { name: 'Uong Bi', slug: 'uong-bi', population: 170000 },
    { name: 'Viet Tri', slug: 'viet-tri', population: 260000 },
    { name: 'My Tho', slug: 'my-tho', population: 169000 },
    { name: 'Da Lat', slug: 'da-lat', population: 206100 },
    { name: 'Cao Lanh', slug: 'cao-lanh', population: 153000 },
    { name: 'Pleiku', slug: 'pleiku', population: 200000 },
    { name: 'Vi Thanh', slug: 'vi-thanh', population: 147000 },
    { name: 'Dong Ha', slug: 'dong-ha', population: 93000 },
    { name: 'Tam Ky', slug: 'tam-ky', population: 108000 },
    { name: 'Kon Tum', slug: 'kon-tum', population: 137000 },
    { name: 'Son La', slug: 'son-la', population: 98000 },
    { name: 'Lai Chau', slug: 'lai-chau', population: 37000 },
    { name: 'Cao Bang', slug: 'cao-bang', population: 52000 },
    { name: 'Lang Son', slug: 'lang-son', population: 75000 },
    { name: 'Lao Cai', slug: 'lao-cai', population: 89000 },
    { name: 'Yen Bai', slug: 'yen-bai', population: 95000 },
    { name: 'Tuyen Quang', slug: 'tuyen-quang', population: 56000 },
    { name: 'Ha Giang', slug: 'ha-giang', population: 48000 },
    { name: 'Dien Bien Phu', slug: 'dien-bien-phu', population: 70000 },
    { name: 'Hoa Binh', slug: 'hoa-binh', population: 122000 },
    { name: 'Phu Ly', slug: 'phu-ly', population: 150000 },
    { name: 'Ha Dong', slug: 'ha-dong', population: 287500 },
    { name: 'Bac Ninh', slug: 'bac-ninh', population: 122000 },
    { name: 'Hung Yen', slug: 'hung-yen', population: 110000 },
    { name: 'Hai Duong', slug: 'hai-duong', population: 200000 },
    { name: 'Bac Giang', slug: 'bac-giang', population: 126000 },
    { name: 'Quang Ninh', slug: 'quang-ninh', population: 180000 },
    { name: 'Hon Gai', slug: 'hon-gai', population: 160000 },
    { name: 'Dong Hoi', slug: 'dong-hoi', population: 120000 },
    { name: 'Thanh Hoa', slug: 'thanh-hoa', population: 197000 },
    { name: 'Ninh Binh', slug: 'ninh-binh', population: 130000 },
    { name: 'Phu Tho', slug: 'phu-tho', population: 63000 },
    { name: 'Ha Tinh', slug: 'ha-tinh', population: 85000 },
    { name: 'Nghe An', slug: 'nghe-an', population: 127000 },
    { name: 'Quang Binh', slug: 'quang-binh', population: 78000 },
    { name: 'Quang Tri', slug: 'quang-tri', population: 85000 },
    { name: 'Thua Thien Hue', slug: 'thua-thien-hue', population: 200000 },
    { name: 'Quang Nam', slug: 'quang-nam', population: 95000 },
    { name: 'Quang Ngai', slug: 'quang-ngai', population: 140000 },
    { name: 'Binh Dinh', slug: 'binh-dinh', population: 175000 },
    { name: 'Phu Yen', slug: 'phu-yen', population: 98000 },
    { name: 'Khanh Hoa', slug: 'khanh-hoa', population: 250000 },
    { name: 'Ninh Thuan', slug: 'ninh-thuan', population: 68000 },
    { name: 'Binh Thuan', slug: 'binh-thuan', population: 180000 },
    { name: 'Gia Lai', slug: 'gia-lai', population: 95000 },
    { name: 'Dak Lak', slug: 'dak-lak', population: 145000 },
    { name: 'Dak Nong', slug: 'dak-nong', population: 55000 },
    { name: 'Lam Dong', slug: 'lam-dong', population: 125000 },
    { name: 'Binh Phuoc', slug: 'binh-phuoc', population: 95000 },
    { name: 'Tay Ninh', slug: 'tay-ninh', population: 180000 },
    { name: 'Binh Duong', slug: 'binh-duong', population: 350000 },
    { name: 'Dong Nai', slug: 'dong-nai', population: 280000 },
    { name: 'Ba Ria Vung Tau', slug: 'ba-ria-vung-tau', population: 200000 },
    { name: 'Long An', slug: 'long-an', population: 145000 },
    { name: 'Tien Giang', slug: 'tien-giang', population: 170000 },
    { name: 'Ben Tre', slug: 'ben-tre', population: 130000 },
    { name: 'Tra Vinh', slug: 'tra-vinh', population: 85000 },
    { name: 'Vinh Long', slug: 'vinh-long', population: 147000 },
    { name: 'Dong Thap', slug: 'dong-thap', population: 165000 },
    { name: 'An Giang', slug: 'an-giang', population: 180000 },
    { name: 'Kien Giang', slug: 'kien-giang', population: 210000 },
    { name: 'Ca Mau', slug: 'ca-mau', population: 195000 },
    { name: 'Bac Lieu', slug: 'bac-lieu', population: 165000 },
    { name: 'Soc Trang', slug: 'soc-trang', population: 173000 },
    { name: 'Hau Giang', slug: 'hau-giang', population: 125000 },
    { name: 'Pho Yen', slug: 'pho-yen', population: 65000 },
    { name: 'Song Cong', slug: 'song-cong', population: 55000 },
    { name: 'Bac Kan', slug: 'bac-kan', population: 35000 },
    { name: 'Cho Moi', slug: 'cho-moi', population: 45000 },
    { name: 'Go Cong', slug: 'go-cong', population: 60000 },
    { name: 'Sa Dec', slug: 'sa-dec', population: 102000 },
    { name: 'Chau Doc', slug: 'chau-doc', population: 157000 },
    { name: 'Tan An', slug: 'tan-an', population: 180000 },
    { name: 'Thu Dau Mot', slug: 'thu-dau-mot', population: 158000 },
    { name: 'Tuy Hoa', slug: 'tuy-hoa', population: 262000 },
    { name: 'Phan Rang', slug: 'phan-rang', population: 94000 },
    { name: 'Ca Na', slug: 'ca-na', population: 25000 },
    { name: 'Dau Giay', slug: 'dau-giay', population: 35000 },
    { name: 'Ben Cat', slug: 'ben-cat', population: 140000 },
    { name: 'Di An', slug: 'di-an', population: 240000 },
    { name: 'Thuan An', slug: 'thuan-an', population: 280000 },
    { name: 'Tan Uyen', slug: 'tan-uyen', population: 200000 },
    { name: 'Dong Xoai', slug: 'dong-xoai', population: 78000 },
    { name: 'Loc Ninh', slug: 'loc-ninh', population: 45000 },
    { name: 'Phuoc Long', slug: 'phuoc-long', population: 32000 },
    { name: 'Binh Long', slug: 'binh-long', population: 28000 }
  ]
};
